import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const [label, setLabel] = useState("");
  const [active, setActive] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.3 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.3 });

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("has-cursor");
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      const link = e.target.closest("a, button, [role=button], input, textarea, select, label");
      setLabel(t ? t.getAttribute("data-cursor") : "");
      setActive(!!(t || link));
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      document.body.classList.remove("has-cursor");
    };
  }, [x, y]);

  if (!enabled) return null;
  const big = !!label;
  return (
    <>
      <motion.div
        aria-hidden="true"
        style={{ x: sx, y: sy }}
        className="cur"
        animate={{ width: big ? 96 : active ? 44 : 10, height: big ? 96 : active ? 44 : 10, backgroundColor: big ? "rgba(201,169,97,1)" : "rgba(201,169,97,0)", borderColor: active ? "rgba(201,169,97,.9)" : "rgba(201,169,97,.0)" }}
        transition={{ type: "spring", stiffness: 300, damping: 28 }}
      >
        <span className="cur-dot" style={{ opacity: active ? 0 : 1 }} />
        <span className="cur-label" style={{ opacity: big ? 1 : 0 }}>{label}</span>
      </motion.div>
      <style dangerouslySetInnerHTML={{ __html: `
        .cur { position: fixed; top: 0; left: 0; z-index: 9999; pointer-events: none; border-radius: 999px; border: 1px solid; translate: -50% -50%;
          display: flex; align-items: center; justify-content: center; mix-blend-mode: normal; }
        .cur-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--gold); transition: opacity .3s; }
        .cur-label { position: absolute; font-family: var(--sans); font-size: .62rem; letter-spacing: .28em; text-transform: uppercase; color: var(--ink); transition: opacity .3s; white-space: nowrap; }
      ` }} />
    </>
  );
}
